module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"emailPlaceholder":"Enter an email address","invalidEmailAddress":"Email address isn\u0027t valid"}}')
  delete Component.options._Ctor
}
